import React from 'react'
import { useInView } from 'react-intersection-observer';
import {BsLinkedin} from 'react-icons/bs'
import {FaGithub} from 'react-icons/fa'
import {SiDiscord} from 'react-icons/si'

const HeaderSocials = () => {
  const { ref: headerSocRef, inView: myElementIsVisible } = useInView();

  let headerSocialStyle = 'header__socials '
  headerSocialStyle += myElementIsVisible ? 'show-from-bottom' : 'hide-from-bottom'
  let logos = myElementIsVisible ? 'show-from-bottom' : 'hide-from-bottom'

  return (
    <div className={headerSocialStyle} ref={headerSocRef}>
        <a className={logos} href="https://www.linkedin.com/in/ram-kenneth-t-6743631a6/" target="_blank" rel="noreferrer"><BsLinkedin/></a>
        <a className={logos} href="https://github.com/ehlwas" target="_blank" rel="noreferrer"><FaGithub/></a>
        <a className={logos} href="https://discordapp.com/users/270461151983304704/" target="_blank" rel="noreferrer"><SiDiscord/></a>
    </div>
  )
}

export default HeaderSocials